import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add-task",
  "use": "add-task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add-task\"><path d=\"M460.8 102.4a51.2 51.2 0 0 0-51.2 51.2V512H51.2a51.2 51.2 0 0 0 0 102.4h358.4v358.4a51.2 51.2 0 0 0 102.4 0V614.4h358.4a51.2 51.2 0 0 0 0-102.4H512V153.6a51.2 51.2 0 0 0-51.2-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol